import { init as initUtil } from '../../500-common/util';

export default function init() {
    try {
        const isInitalized = initUtil();

        if (isInitalized) {
            const elements = document.querySelectorAll('[data-klt-c-text-expand]');

            if (elements.length > 0) {
                elements.forEach(element => {
                    if (element.clientHeight > 180) {
                        element.classList.add('klt-c-text-expand--js');
                    }
                });
            }
        }
    } catch (e) {
        console.error(`Couldn't initalize text expand module`, e);
    }
}
